export default __webpack_public_path__ + "static/uma-mission-5866b25f185c01ab17156f72c8242392.jpg";